import React, { Component } from 'react';
import { FormField, Label, ErrorMessage } from '../../../styles/style';

class CheckboxField extends Component {
  render() {
    let { name, label, disabled, update, onFocus, value, errorMessage } = this.props;
    
    return (
      <Label style={{whiteSpace: 'nowrap'}}>
        <input name={name} id={name} checked={value} disabled={disabled} onChange={update} onFocus={onFocus} type="checkbox"/> {label}
        {errorMessage[name] && (<ErrorMessage>{errorMessage[name]}</ErrorMessage>)}
      </Label>
    )
  }
}

export default CheckboxField;
